import { render, staticRenderFns } from "./TextNav.vue?vue&type=template&id=413e7852&scoped=true"
import script from "./TextNav.vue?vue&type=script&lang=js"
export * from "./TextNav.vue?vue&type=script&lang=js"
import style0 from "./TextNav.vue?vue&type=style&index=0&id=413e7852&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413e7852",
  null
  
)

export default component.exports